import { DRAWER_WIDTH, APPBAR_HEIGHT} from '../../constants';
const drawerWidth = DRAWER_WIDTH;
const appBarHeight = APPBAR_HEIGHT;

const styles = theme => ({
    root: {
        display: "flex",
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        display: "flex",
        alignItems: "center"
    },
    drawerHeader: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        height: `calc(100vh - ${appBarHeight}px)`,
        flexGrow: 1,
        padding: 0,
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    container: {
        width: "90%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
    buttons: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between"
    },
    button: {
        width: "48%"
    }
});

export default styles;